import { Placement } from '@floating-ui/react';
import React, { PropsWithChildren, useRef } from 'react';

import { useClipboard } from 'utils/hooks';

import { Tooltip } from './Tooltip';

interface CopyToClipboardProps {
    textToCopy?: string;
    tooltip?: string;
    wait?: number;
    disabled?: boolean;
    tooltipPlacement?: Placement;
}

export const CopyToClipboard = ({
    textToCopy = '',
    tooltip = 'Copy to Clipboard',
    wait = 1000,
    children,
    disabled,
    tooltipPlacement = 'top',
}: PropsWithChildren<CopyToClipboardProps>) => {
    const ref = useRef<HTMLDivElement>(null);
    const { isCopied, copy } = useClipboard({
        timeoutMs: wait,
        onError: (error) => {
            console.error('Failed to copy text:', error);
        },
    });

    const copyToClipboard = () => {
        const text = textToCopy || ref.current?.textContent || '';
        void copy(text, { suppressPropagation: false });
    };

    if (disabled) {
        return children;
    }

    return (
        <Tooltip tooltip={isCopied ? 'Copied' : tooltip} placement={tooltipPlacement}>
            <div ref={ref} onClick={copyToClipboard}>
                {children}
            </div>
        </Tooltip>
    );
};
